import { __assign } from 'tslib';
import React from 'react';
import Pagination from '../../../Pagination/Pagination.js';
import Select from '../../../Select/Select.js';
import clsx from 'clsx';
import '../../../../tailwind.css.js';

var Footer = function (props) {
    var _a;
    var onChange = function (pg) {
        var _a, _b;
        props.pagination.setPage(pg);
        (_b = (_a = props.paginationProps) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, pg);
    };
    return (React.createElement("div", { "data-testid": 'footer', className: clsx('flex items-center justify-between h-[56px]', props.className) },
        !props.noPageSizes &&
            React.createElement("div", { "data-testid": 'page-sizes', className: 'flex items-center w-fit' },
                ((_a = props.pageSizes) === null || _a === void 0 ? void 0 : _a.length) !== 1 &&
                    React.createElement(React.Fragment, null,
                        React.createElement("span", { className: 'text-dark-text leading-6 select-none whitespace-nowrap' }, props.label || 'Rows:'),
                        React.createElement(Select, { className: 'w-[76px] mx-2', size: 'sm', items: props.pageSizes ? props.pageSizes : [10, 25, 50, 100], value: props.pagination.size, onChange: props.setPageSize, options: props.options })),
                React.createElement("span", { className: 'text-dark-text leading-6 select-none whitespace-nowrap' }, "".concat(props.pagination.start, "-").concat(props.pagination.end)),
                !!props.pagination.count && (React.createElement("span", { className: 'text-dark-text leading-6 select-none whitespace-nowrap' },
                    "\u00A0", "of ".concat(props.pagination.count)))),
        React.createElement(Pagination, __assign({}, props.paginationProps, { page: props.pagination.page, pages: props.pagination.pages, onChange: onChange, className: "only:ml-auto" }))));
};

export { Footer as default };
